import React, {Component} from 'react';
import {
    Link
} from "react-router-dom";
import api from "../../../api";
import Menu from "../../Menu";
import PageHeader from "../../PageHeader";
import GlobalVariable from "../../../GlobalVariable";
import axios from "axios";

export class KnowledgeBase1 extends Component <any, any> {
    constructor(props: any) {
        super(props);window.scrollTo(0, 0);
        this.state = {
            lesson: []
        };
    }

    componentDidMount() {
        let urlAPI = GlobalVariable.staffBack() + '/getCategoryShowLesson/' + this.props.idCategory;
        let data = {};
        api({
            url: urlAPI,
            headers: {'Content-Type': 'application/json'},
            method: "post",
            data: data,
            withCredentials: true,
            // receive two    parameter endpoint url ,form data
        })
            .then(result => { // then print response status
                this.setState({'lesson': result.data})
            }).catch(error => {

            // window.location.href = '/' ;
        })
    }

    render() {
        return (
            <div className='main knowledge-base'>
                <div className='content mx-w-content'>
                    <PageHeader
                        pageTitle='Список уроков'
                        backBtnUrl='/knowledge-base'/>
                    <div className='pt-header'></div>
                    {
                        this.state.lesson.map((item) => (
                            <div className='ml-3 mr-3 mb-2'>

                                <Link to={'/knowledge-base/' + this.props.idCategory + '/lesson/' + item.id}
                                      className='chio-card'>
                                    <img className='card-img-left mr-2' src={item.img_url} alt=''/>
                                    <div className='p-3 d-flex flex-column justify-content-between'
                                         style={{width: '70%'}}>
                                        <h2 className='mb-0 txt-middle'>{item.title} </h2>
                                        <div className='d-flex align-items-center'>
                                            <img className='ico' src='/img/knowledge-base/ico-clock-red.svg' alt=''/>
                                            <span className='ml-2 txt-small'>{item.time}</span>
                                        </div>
                                    </div>
                                </Link>


                            </div>))
                    }

                </div>
                <Menu></Menu>
            </div>
        )
    }
}

export default KnowledgeBase1;